import axios from 'axios';

import config from '../config';

class ReportErrorApi {
  static sendMessage(restaurant, message, url) {
    if (config.mockApi) {
      return Promise.resolve({});
    }
    return axios
      .post(`${config.apiUrl}/reporterror/`, {restaurant, message, url})
      .then(res => res.data);
  }
}

export default ReportErrorApi;



// WEBPACK FOOTER //
// ./api/reporterror.api.js